export default "/images/video.svg?efc11746ef749d844e0c8345173e8f43";